import { campaignStatusClass, journeyStatusClass } from '../constants';

type Props = {
  status: string;
  kind?: 'campaign' | 'journey';
};

export function MarketingStatusBadge({ status, kind = 'campaign' }: Props) {
  const cls = kind === 'journey' ? journeyStatusClass(status) : campaignStatusClass(status);
  return (
    <span className={`inline-flex px-2 py-0.5 rounded-md text-xs font-medium ${cls}`}>
      {status.replace(/_/g, ' ')}
    </span>
  );
}
